// src/pages/nascar/XFPractice.jsx
import React from "react";
import NascarPracticePage from "../../components/NascarPracticePage";

export default function XFPractice() {
  const BASE = import.meta?.env?.BASE_URL ?? "/";

  return (
    <NascarPracticePage
      title="Xfinity Practice Data"
      summarySrc={`${BASE}data/nascar/xfinity/latest/practice_cons.json`}
      lapsSrc={`${BASE}data/nascar/xfinity/latest/practice_laps.json`}
      showSources={false}
    />
  );
}
